<template>
  <v-container fluid style="background-color: rgb(0,0,0)" >
    <HomePage  />
  </v-container>

</template>

<script>


import HomePage from "../components/home/Home";
export default {
  components: {
    HomePage
  },
};
</script>
